<script lang="ts">
	import { EditionsRoutes } from '#lib/websites/editions/constants/routes.js';
	import { page } from '$app/state';
	import ArtworkCard from '$global/components/ArtworkCard/ArtworkCard.svelte';
	import { Txt } from '$global/components/Txt';
	import { getImageUrl } from '$global/utils/getImageUrl';
	import { getPageData } from '$global/utils/getPageData/getPageData';
	import type { SeriesPageData } from '$routes/editions/series/[slug]/types';

	const dataCy = 'series';

	let data = $derived(getPageData<SeriesPageData>(page.data));

	let series = $derived(data.series);

	let subSeries = $derived(
		series?.sub_series?.map((item) => {
			return item?.related_Series_id;
		})
	);
</script>

{#if subSeries && subSeries.length}
	<div class="mb-24">
		<Txt variant="h2" class="mb-6">Sub-Series</Txt>

		<hr class="mt-8 mb-10 hidden border-t border-t-gray-200 sm:block" />

		<div
			class="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-6 lg:grid-cols-4 lg:gap-8"
		>
			{#each subSeries as subseriesItem}
				<ArtworkCard
					{dataCy}
					line1={series?.artists
						?.map((artist) => artist?.Artists_id?.name)
						?.join(', ') || ''}
					line2={subseriesItem?.name || ''}
					href={`${EditionsRoutes.Series}/${subseriesItem?.slug}`}
					image={{
						width: subseriesItem?.image?.width || 0,
						height: subseriesItem?.image?.height || 0,
						url:
							getImageUrl(subseriesItem?.image?.filename_disk, '512px') || '',
					}}
					alt={subseriesItem?.name || ''}
				/>
			{/each}
		</div>
	</div>
{/if}
